require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



// WEBPACK FOOTER //
// D:/a/vallentuna-public/vallentuna-public/node_modules/core-js/fn/regexp/escape.js